import { CheckCircle2, XCircle, RefreshCw as RefIcon, Clock, ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

// StatusTotalCards — widget reutilizável (Dashboard + Relatórios)
// Props:
//   totals: { total, status: {concluidas, canceladas, remarcadas, pendentes, aguardando, em_transito},
//             previous?: { total, status: {...}, period: {start, end} } }
//   compact: reduz padding e tamanhos para caber em widgets embutidos
//   testIdPrefix: prefixo dos data-testids (default "status-card")

const STATUS_CARDS = [
  { key: "concluidas", label: "Concluídas", Icon: CheckCircle2, cls: "bg-emerald-50 border-emerald-200 text-emerald-700", dot: "bg-emerald-500" },
  { key: "canceladas", label: "Canceladas", Icon: XCircle,      cls: "bg-rose-50 border-rose-200 text-rose-700",         dot: "bg-rose-500" },
  { key: "remarcadas", label: "Remarcadas", Icon: RefIcon,      cls: "bg-amber-50 border-amber-200 text-amber-800",       dot: "bg-amber-500" },
  { key: "pendentes",  label: "Pendentes",  Icon: Clock,        cls: "bg-blue-50 border-blue-200 text-blue-700",          dot: "bg-blue-500" },
];

function Delta({ current, previous }) {
  if (previous == null) return null;
  const diff = current - previous;
  const pct = previous > 0 ? Math.round((diff / previous) * 100) : (current > 0 ? 100 : 0);
  const color = diff > 0 ? "text-emerald-700" : diff < 0 ? "text-rose-700" : "text-slate-500";
  const Icon = diff > 0 ? ArrowUpRight : diff < 0 ? ArrowDownRight : Minus;
  const sign = diff > 0 ? "+" : "";
  return (
    <div className={`text-[10px] font-semibold flex items-center gap-0.5 ${color}`} title={`Período anterior: ${previous}`}>
      <Icon className="w-3 h-3" />
      <span>{sign}{diff}</span>
      {previous > 0 && <span className="opacity-70">({sign}{pct}%)</span>}
    </div>
  );
}

export function StatusTotalCards({ totals, compact = false, testIdPrefix = "status-card" }) {
  const totalAll = totals?.total ?? 0;
  const pct = (n) => (totalAll > 0 ? Math.round((n / totalAll) * 100) : 0);
  const gapCls = compact ? "gap-2" : "gap-3";
  const pad = compact ? "pt-3 pb-2 px-3" : "pt-4 pb-3";
  return (
    <div className={`grid grid-cols-2 lg:grid-cols-4 ${gapCls}`}>
      {STATUS_CARDS.map((c) => {
        const val = totals?.status?.[c.key] ?? 0;
        const prev = totals?.previous?.status?.[c.key];
        return (
          <Card key={c.key} className={`border-2 ${c.cls}`} data-testid={`${testIdPrefix}-${c.key}`}>
            <CardContent className={pad}>
              <div className="flex items-center justify-between mb-1">
                <span className={`${compact ? "text-[10px]" : "text-xs"} font-bold uppercase tracking-wide`}>{c.label}</span>
                <c.Icon className={`${compact ? "w-4 h-4" : "w-5 h-5"} opacity-80`} />
              </div>
              <div className="flex items-baseline gap-2">
                <div className={`${compact ? "text-2xl" : "text-4xl"} font-extrabold`} data-testid={`${testIdPrefix}-count-${c.key}`}>{val}</div>
                <div className="text-xs opacity-70">{pct(val)}%</div>
              </div>
              <div className={`${compact ? "mt-1" : "mt-2"} h-1.5 rounded-full bg-white/60 overflow-hidden`}>
                <div className={`h-full ${c.dot}`} style={{ width: `${pct(val)}%` }} />
              </div>
              <div className="mt-1"><Delta current={val} previous={prev} /></div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
